import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsButtonComponent } from "./ds-button.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatIconModule } from "@angular/material/icon";

@NgModule({
  declarations: [DsButtonComponent],
  imports: [CommonModule, MatProgressSpinnerModule, MatIconModule],
  exports: [DsButtonComponent],
})
export class DsButtonModule {}
